module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/path.js
// module id = 5
// module chunks = 0 1